// src/components/Exaustores/ExaustorMessage/ExaustorMessage.jsx
/**
 * Componente genérico para mensagens de estado do exaustor
 * Facilmente extensível para novos tipos de mensagens
 */
import React from "react";
import { getManualType } from "../../../utils/utilsExaustor";

/**
 * Mensagem genérica de estado do exaustor
 * @param {string} type - Tipo da mensagem ("manual" | "dependente" | "manutencao" | ...)
 * @param {Object} data - Dados específicos para cada tipo de mensagem
 */
const ExaustorMessage = ({ type, data = {} }) => {
  // Renderiza mensagem baseada no tipo
  const renderMessage = () => {
    switch (type) {
      case "manual":
        return renderManualMessage(data);
      
      case "dependente":
        return renderDependenteMessage(data);
      
      // 🆕 FÁCIL ADICIONAR NOVOS TIPOS!
      // case "manutencao":
      //   return renderManutencaoMessage(data);
      
      // case "emergencia":
      //   return renderEmergenciaMessage(data);
      
      // case "agendado":
      //   return renderAgendadoMessage(data);
      
      default:
        console.warn(`Tipo de mensagem desconhecido: ${type}`);
        return null;
    }
  };

  // ==================== MANUAL ====================
  const renderManualMessage = ({ modoManual }) => {
    const tipo = getManualType(modoManual);
    
    return (
      <>
        Exaustor ligado manualmente{" "}
        {tipo === "manualBT" ? (
          <>
            através do <strong>Botão Físico</strong>
          </>
        ) : (
          <>
            pelo <strong>SAP</strong>
          </>
        )}
      </>
    );
  };

  // ==================== DEPENDENTE ====================
  const renderDependenteMessage = ({ mestres = [] }) => {
    return (
      <>
        Exaustor ativo em <strong>modo dependente</strong>
        {mestres && mestres.length > 0 ? (
          <>
            , pois o mestre <strong>{mestres.join(", ")}</strong> está ligado.
          </>
        ) : (
          <>.</>
        )}
      </>
    );
  };

  // ==================== EXEMPLOS DE NOVAS MENSAGENS ====================
  
  // 🆕 EXEMPLO: Modo Manutenção
  // const renderManutencaoMessage = ({ tecnico, dataInicio }) => {
  //   return (
  //     <>
  //       Exaustor em <strong>modo manutenção</strong>
  //       {tecnico && (
  //         <>
  //           {" "}por <strong>{tecnico}</strong>
  //         </>
  //       )}
  //       {dataInicio && (
  //         <>
  //           {" "}desde <strong>{dataInicio}</strong>
  //         </>
  //       )}
  //       .
  //     </>
  //   );
  // };

  // 🆕 EXEMPLO: Modo Emergência
  // const renderEmergenciaMessage = ({ motivo }) => {
  //   return (
  //     <>
  //       ⚠️ <strong>MODO EMERGÊNCIA ATIVADO</strong>
  //       {motivo && (
  //         <>
  //           : {motivo}
  //         </>
  //       )}
  //     </>
  //   );
  // };

  // 🆕 EXEMPLO: Agendado
  // const renderAgendadoMessage = ({ horaInicio, horaFim }) => {
  //   return (
  //     <>
  //       Exaustor <strong>agendado</strong> para ligar às{" "}
  //       <strong>{horaInicio}</strong> e desligar às{" "}
  //       <strong>{horaFim}</strong>.
  //     </>
  //   );
  // };

  return <div className="exaustores_text">{renderMessage()}</div>;
};

export default ExaustorMessage;

/**
 * 📚 EXEMPLOS DE USO:
 * 
 * // Modo Manual
 * <ExaustorMessage 
 *   type="manual" 
 *   data={{ modoManual: "ManualBT" }} 
 * />
 * 
 * // Modo Dependente
 * <ExaustorMessage 
 *   type="dependente" 
 *   data={{ mestres: ["Exaustor 1", "Exaustor 2"] }} 
 * />
 * 
 * // 🆕 Modo Manutenção (futuro)
 * <ExaustorMessage 
 *   type="manutencao" 
 *   data={{ tecnico: "João Silva", dataInicio: "20/10/2024" }} 
 * />
 * 
 * // 🆕 Modo Emergência (futuro)
 * <ExaustorMessage 
 *   type="emergencia" 
 *   data={{ motivo: "Detecção de fumaça" }} 
 * />
 * 
 * // 🆕 Agendado (futuro)
 * <ExaustorMessage 
 *   type="agendado" 
 *   data={{ horaInicio: "08:00", horaFim: "18:00" }} 
 * />
 */